import { useState } from 'react'
import { nodes as api } from '@/api/endpoints'
import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Err } from '@/components/Err'

// 노드 상세의 고급 행 `편입`(#101). 기존 클러스터에서 편입한 노드에 관리 도구를 올린다 — 처음이든, 끊겼거나
// 실패한 뒤의 재시도든 같은 버튼이다. 주소·호스트 키는 묻지 않는다(백엔드가 관리 주소와 기록된 키로 정한다).
// root 비밀번호는 대화 상자의 state 에만 있고 닫으면 비운다. 시작한 뒤의 진행은 노드의 국면이 말한다.
export function NodeOnboardRow({ nodeId }: { nodeId: string }) {
  const [open, setOpen] = useState(false)
  const [password, setPassword] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<unknown>(null)
  const close = () => {
    setOpen(false)
    setPassword('')
    setError(null)
  }
  const start = async () => {
    setBusy(true)
    setError(null)
    try {
      await api.onboard(nodeId, password)
      close()
    } catch (err) {
      setError(err)
    } finally {
      setBusy(false)
    }
  }
  return (
    <>
      <div>
        <Button size="sm" variant="outline" onClick={() => setOpen(true)}>
          편입 시작
        </Button>
      </div>
      <Dialog open={open} onOpenChange={(next) => (busy ? undefined : next ? setOpen(true) : close())}>
        <DialogContent aria-describedby={undefined}>
          <DialogHeader>
            <DialogTitle>편입 시작</DialogTitle>
          </DialogHeader>
          <div className="grid gap-2">
            <Label htmlFor="node-onboard-password">root 비밀번호</Label>
            <Input
              id="node-onboard-password"
              type="password"
              autoComplete="off"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
          </div>
          <Err error={error} />
          <DialogFooter>
            <Button variant="outline" disabled={busy} onClick={close}>
              취소
            </Button>
            <Button disabled={busy || !password} onClick={() => void start()}>
              {busy ? '시작 중' : '시작'}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  )
}
